import { FunctionComponent, useState } from 'react';
import { Button } from '@gaiads/telia-react-component-library';
import { showGrowlNotification } from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { initializeWebshopState } from '../../utils';
import { RootState } from '../../store/reducers';
import { useTranslation } from 'react-i18next';

const WebshopButton: FunctionComponent = () => {
  const dispatch = useDispatch();
  const orderingForOrganization = useSelector((state: RootState) => state.shop.orderForOrganization);
  const orderingOnBehalfUserData = useSelector((state: RootState) => state.shop.orderOnBehalfUser);
  const user = useSelector((state: RootState) => state.authentication.user);
  const { t } = useTranslation('shop');

  const [loading, setLoading] = useState(false);

  const onClick = () => {
    const orderToUser = orderingForOrganization ? null : orderingOnBehalfUserData.status ? orderingOnBehalfUserData.userToOrderFor : user;

    setLoading(true);

    initializeWebshopState(orderToUser).then(response => {
      if (response) {
        const url = new URL(process.env.REACT_APP_WEBSHOP_REDIRECT_URL!);
        url.searchParams.append('id', response.id);
        window.location.assign(url);
      } else {
        dispatch(showGrowlNotification(t('externalWebshop.saveWebshopStateFailed'), 'error'));
        setLoading(false);
      }
    });
  };

  return (
    <Button onClick={onClick} loading={loading} variant="secondary">
      {t('externalWebshop.toShopButton')}
    </Button>
  );
};

export default WebshopButton;
